import { useState } from 'react';
import * as React from 'react';
import {
    BodyMediumEmphasized,
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    Sheet,
    Switch,
    XStack,
    YStack,
} from 'smoothie';

const ApplyIncomeSplitSheet = ({
    isOpen,
    onClose,
    onPress,
    applyIncomeSplit,
}: {
    isOpen: boolean;
    onClose: () => void;
    onPress: (isChecked: boolean) => void;
    applyIncomeSplit: boolean;
}) => {
    const [isChecked, setIsChecked] = useState<boolean>(applyIncomeSplit);
    return (
        <Sheet
            isOpen={isOpen}
            onClose={onClose}
            renderInAppRoot={false}
            disableDrag
            title="Apply Income Split rules"
            showCloseButton
        >
            <YStack maxHeight={600} $sm={{ width: 400, alignSelf: 'center' }}>
                <YStack>
                    <XStack
                        alignItems="center"
                        justifyContent="space-between"
                        marginBottom={12}
                        marginTop={10}
                    >
                        <BodyMediumEmphasized>
                            Apply Income Split rules?
                        </BodyMediumEmphasized>
                        <Switch
                            isChecked={isChecked}
                            onCheckedChange={(checked) => {
                                setIsChecked(checked);
                            }}
                            style={{ marginRight: -5 }}
                        />
                    </XStack>
                    <BodyMediumRegular color="$gray900" marginBottom={24}>
                        By enabling, your Income Split rules will be applied to
                        these recurring transfers
                    </BodyMediumRegular>
                    <Button
                        variant={ButtonVariant.PRIMARY}
                        size={ButtonSize.LARGE}
                        text="Save"
                        onPress={() => {
                            onPress(isChecked);
                        }}
                    />
                </YStack>
            </YStack>
        </Sheet>
    );
};

export default ApplyIncomeSplitSheet;
